// extracted by mini-css-extract-plugin
export default {"header":"ActTeamManagement_header__7cQXH"};